import { createSlice } from "@reduxjs/toolkit";

const SchemaObject = createSlice({
  name: "SchemaObject",
  initialState: "",
  reducers: {
    saveSchemaObject: (state, action) => action.payload,
  },
});

export default SchemaObject;
